var _g, _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientArrivalReqDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_557_188086)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#3E74B5",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#3E74B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9163 31.166C79.0209 31.166 79.9163 32.0614 79.9163 33.166V69.8327C79.9163 70.9373 79.0209 71.8327 77.9163 71.8327H31.083C29.9784 71.8327 29.083 70.9373 29.083 69.8327V33.166C29.083 32.0614 29.9784 31.166 31.083 31.166H77.9163ZM72.2913 58.4889C72.2913 57.4361 71.4379 56.5827 70.3851 56.5827H58.9476C57.8948 56.5827 57.0413 57.4361 57.0413 58.4889C57.0413 59.5417 57.8948 60.3952 58.9476 60.3952H70.3851C71.4379 60.3952 72.2913 59.5417 72.2913 58.4889ZM44.0153 49.7202H42.109C39.0886 49.7202 36.537 51.7695 35.715 54.6083C35.4079 55.6693 36.3326 56.5827 37.4372 56.5827H48.6872C49.7917 56.5827 50.7164 55.6693 50.4084 54.6085C49.5839 51.7696 47.0259 49.7202 44.0153 49.7202ZM72.2913 50.8639C72.2913 49.8111 71.4379 48.9577 70.3851 48.9577H58.9476C57.8948 48.9577 57.0413 49.8111 57.0413 50.8639C57.0413 51.9167 57.8948 52.7702 58.9476 52.7702H70.3851C71.4379 52.7702 72.2913 51.9167 72.2913 50.8639ZM43.0622 40.5336C41.2198 40.5336 39.7262 42.0271 39.7262 43.8695C39.7262 45.7119 41.2198 47.2055 43.0622 47.2055C44.9046 47.2055 46.3981 45.7119 46.3981 43.8695C46.3981 42.0271 44.9046 40.5336 43.0622 40.5336ZM72.2913 43.2389C72.2913 42.1861 71.4379 41.3327 70.3851 41.3327H58.9476C57.8948 41.3327 57.0413 42.1861 57.0413 43.2389C57.0413 44.2917 57.8948 45.1452 58.9476 45.1452H70.3851C71.4379 45.1452 72.2913 44.2917 72.2913 43.2389Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_557_188086",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_557_188086"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_557_188086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_557_188086",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_557_188086"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientArrivalReqDetails);
export default __webpack_public_path__ + "static/media/PatientArrivalReqDetails.61228875486a1f037ff1910492a46ecc.svg";
export { ForwardRef as ReactComponent };